/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import { HorizontalBarChart } from '@atlassian/viz-platform-charts--next/charts';
import { element, useElementProps } from '@atlassian/viz-platform-charts--next/core';

export const CustomAxisLeftText = element(
	({ sideBarWidth }) => {
		const { children } = useElementProps(HorizontalBarChart.elements.AxisLeftText);

		return (
			<div
				css={axisStyles}
				// We want to scale the width of the axis text relative to the width of the side bar
				// eslint-disable-next-line jira/react/no-style-attribute
				style={{
					maxWidth: `calc(${sideBarWidth / 3}px)`,
				}}
			>
				<span>{children?.toString()}</span>
			</div>
		);
	},
	{ as: HorizontalBarChart.elements.AxisLeftText },
);

const axisStyles = css({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
});
